/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsFeedListForUserResponse } from '../../models/news-feed-list-for-user-response';

export interface GetNewsFeed$Params {
  offset: number;
  limit: number;

/**
 * Unix timestamp when was newsfeed open (to exclude already viewed posts)
 */
  ts?: number;
}

export function getNewsFeed(http: HttpClient, rootUrl: string, params: GetNewsFeed$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsFeedListForUserResponse>> {
  const rb = new RequestBuilder(rootUrl, getNewsFeed.PATH, 'get');
  if (params) {
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
    rb.query('ts', params.ts, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsFeedListForUserResponse>;
    })
  );
}

getNewsFeed.PATH = '/rest/newsfeed/{offset}/{limit}';
